import { Exception } from "util/domain/exception";

export enum UploadError {
    FILE_NOT_FOUND = 'FILE_NOT_FOUND',
    DEFAULT = 'DEFAULT',
    FILE_TYPE_MISMATCH = 'FILE_TYPE_MISMATCH'
}

export class UploadException extends Exception<UploadError>{
    constructor(
        public gettextCatalog:ng.gettext.gettextCatalog,
        errorCode:UploadError,
        fileName:string
    ){
        super(errorCode, UploadError[errorCode], 'An upload exception occurred');
        this.userMessage = this.generateUserMessage(fileName);
    }
    private generateUserMessage(fileName:string) {
        let msg = this.gettextCatalog.getString(`File ${fileName} encountered an error uploading`);
        switch(this.type){
            case UploadError.FILE_NOT_FOUND:
                msg = this.gettextCatalog.getString(`File not found`);
                break;
            case UploadError.FILE_TYPE_MISMATCH: 
                msg = this.gettextCatalog.getString(`Upload Error: File type mismatch`);
                break;
        }

        return msg;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/upload-exception.ts